export enum ClinicPaymentMethod {
  CashMoney = 'CashMoney',
  CardsPayment = 'CardsPayment',
}
